import { custom } from 'utils/Api';

const APIH = '/api';

export const getPMEmployeeAppraisal = id => custom.get(`${APIH}/PMEmployeeAppraisalDto/${id}`);

export const updatePMEmployeeAppraisal = (data, id) => custom.post(`${APIH}/PMEmployeeAppraisalDto/UpdateAppraisalAnswersAndStatus?key=${id}`, data);

export const getPMEmployeeAppraisals = () => custom.get(`${APIH}/PMEmployeeAppraisalDto`);



// WEBPACK FOOTER //
// ./src/containers/pmappraisals/api.js